<template>
    <!-- dialog add docs -->
    <dialogTemplate
            :openDialog="isOpen"
            :widthDialog="'800px'"
            :classDialog="'add-docs-dialog'"
            @closeDialog="$emit('closeDialog')"
            @closed="$emit('closed')"
            :appendToBody="true"
            :modalAppendToBody="true"
    >
        <template #header>
            <div class="margin-left-10">
                <h5 class="dialogTitle">Danh sách đơn vị ban hành văn bản</h5>
            </div>
        </template>
        <template #body>
            <div class="margin-bottom-10" style="max-height: 300px">
                <el-table
                        ref="multipleTable"
                        :data="vbIncomingDocs"
                        size="medium"
                        style="width: 100%"
                >
                    <el-table-column label="STT" width="50" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="">{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Đơn vị nhận văn bản"
                            width="400"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span class="">{{ scope.row.toDeptName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Thời gian nhận" width="150">
                        <template slot-scope="scope">
                          <span class="">{{
                            convertTimeToString(scope.row.createTime)
                          }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Tình trạng xử lý" width="120">
                        <template slot-scope="scope">
                            <span class="clickable">{{ scope.row.processStatusLabel }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
        <template #footer></template>
    </dialogTemplate>
</template>

<script>
  import dateFormatter from "../../../filters/dateFormatter";
  import constants from "../../../constants";
  import incomingDocService from "../../../services/incomingDocService";
  import vbOutgoingDocReceiversService from "../../../services/vbOutgoingDocReceiversService";
  import h from "../../../services/h";

  export default {
    name: "vbdi-process-moreinfo-banhanh",
    props: ["isOpen", "docId"],
    filters: {dateFormatter},
    components: {
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    data() {
      return {
        perfectScrollbarSetting: {
          maxScrollbarLength: 550
        },
        vbIncomingDocs: []
      };
    },
    created() {
      Promise.all([
        this.loadClonedVbIncomingDocs(),
        this.loadDocReceivers()
      ]).then(results => {
        let vbIncomingDocs = results[0];
        let docReceiverOthers = results[1];
        this.initVbIncomingDocs(vbIncomingDocs, docReceiverOthers);
      });
    },
    methods: {
      initVbIncomingDocs(vbIncomingDocs, docReceiverOthers) {
        this.vbIncomingDocs = [];
        this.vbIncomingDocs.push(
          ...h.collect(vbIncomingDocs, vbIncomingDoc => {
            return {
              toDeptName: vbIncomingDoc.toDeptName,
              createTime: vbIncomingDoc.createTime,
              processStatusLabel: this.processStatusLabel(vbIncomingDoc)
            };
          })
        );
        this.vbIncomingDocs.push(
          ...h.collect(docReceiverOthers, docReceiverOther => {
            return {
              toDeptName: docReceiverOther.objectName,
              createTime: docReceiverOther.createTime,
              processStatusLabel: this.processStatusLabelForBanHanhNgoai(
                docReceiverOther
              )
            };
          })
        );
      },

      loadDocReceivers() {
        return vbOutgoingDocReceiversService
          .findAll({docId: this.docId})
          .then(response => {
            let docReceivers = response.data;
            return h.findAll(
              docReceivers,
              docReceiver =>
                docReceiver.objectType !== constants.RECEIVER_OBJECT_TYPE.DONVI
            );
          });
      },

      convertTimeToString(value) {
        return dateFormatter(value);
      },

      processStatusLabelForBanHanhNgoai(docReceiverOther) {
        switch (docReceiverOther.receiveStatus) {
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.DA_DEN:
            return "Chưa tiếp nhận";
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.CHO_PHAN_HOI:
            return "Chờ phản hồi";
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.DANG_XU_LY:
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.PHAN_CONG:
            return "Đang xử lý";
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.HOAN_THANH:
            return "Hoàn thành";
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.TIEP_NHAN:
            return "Đã tiếp nhận";
          case constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS
            .TU_CHOI_TIEP_NHAN:
            return "Từ chối tiếp nhận";
          default:
            return "-";
        }
      },

      processStatusLabel(vbIncomingDoc) {
        switch (vbIncomingDoc.status) {
          case constants.INCOMING_DOC_STATUS.TAO_MOI:
            return "Chưa tiếp nhận";
          case constants.INCOMING_DOC_STATUS.DANG_XU_LY:
            return "Đã xử lý";
          case constants.INCOMING_DOC_STATUS.DA_THU_HOI:
            return "Đã thu hồi";
          case constants.INCOMING_DOC_STATUS.TU_CHOI_TIEP_NHAN:
            return "Từ chối tiếp nhận";
          default:
            return "-";
        }
      },

      loadClonedVbIncomingDocs() {
        return incomingDocService
          .findAllByVbOutgoingDocId(this.docId)
          .then(response => response.data);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/vbdi-process-moreinfo-banhanh.vue